module.exports = __webpack_public_path__ + "static/media/dark-modulo-pesquisa.c63fdf63.svg";